/**
 * Image Downloader
 *
 * Exposes its UI icons to every origin.
 *
 * Behavioural discovery (tooling/batch-interactions.js) found no usable page-side
 * marker, so detection falls back to resource probing.
 * Manifest verified against version 4.5.3.
 */
import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'cnpniohnfphhjihaiiggeabnkjhpaldj';
export const imageDownloader: ExtensionDefinition = {
  id: ID,
  name: "Image Downloader",
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 2000000,
  notes: "Exposes its UI icons to every origin.",
  signals: [
    { id: 'war-images-chevron-svg', kind: 'web-accessible-resource',
      description: 'Load images/chevron.svg via <img>, exposed to every origin.',
      weight: 1, run: () => probeImage(ID, 'images/chevron.svg') },
    { id: 'war-images-copy-svg', kind: 'web-accessible-resource',
      description: 'Load images/copy.svg via <img>, exposed to every origin.',
      weight: 0.5, run: () => probeImage(ID, 'images/copy.svg') },
  ],
};
